import { http } from '@/http'

// CDEF011 §5: firmantes por empresa, catálogo de roles, asignación por empresa, firmantes del tipo y cobertura.
export default {
  listSigners(companyId)            { return http.get(`/companies/${companyId}/signers`) },
  createSigner(companyId, data)     { return http.post(`/companies/${companyId}/signers`, data) },
  updateSigner(id, data)            { return http.put(`/company-signers/${id}`, data) },
  signerStatus(id, status)          { return http.put(`/company-signers/${id}/status`, null, { params: { status } }) },
  linkUser(id, keycloakUserId)      { return http.put(`/company-signers/${id}/keycloak-user`, { keycloakUserId }) },

  listRoles(companyId)              { return http.get('/signer-roles', { params: companyId ? { companyId } : {} }) },
  createRole(data)                  { return http.post('/signer-roles', data) },
  renameRole(id, name)              { return http.put(`/signer-roles/${id}`, { name }) },
  roleStatus(id, status)            { return http.put(`/signer-roles/${id}/status`, null, { params: { status } }) },

  assignments(companyId)            { return http.get(`/companies/${companyId}/signer-roles`) },
  assign(companyId, roleId, signerId) { return http.put(`/companies/${companyId}/signer-roles/${roleId}`, { signerId }) },
  unassign(companyId, roleId)       { return http.delete(`/companies/${companyId}/signer-roles/${roleId}`) },

  documentSigners(typeId)           { return http.get(`/document-types/${typeId}/signers`) },
  replaceDocumentSigners(typeId, list) { return http.put(`/document-types/${typeId}/signers`, list) },

  coverage(companyId)               { return http.get('/signer-coverage', { params: companyId ? { companyId } : {} }) },
}
